module.exports = __webpack_public_path__ + "img/zd-top-1.f5bef413.svg";